import React, { useState, useRef, useEffect } from "react";
import { endPoints, P2PsportEndPoint } from "../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
  getAllSportData,
} from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import { AiOutlineEdit } from "react-icons/ai";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
// import moment from "moment-timezone";
import moment from "moment";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import { DataGrid } from "@mui/x-data-grid";
function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const BetResult = () => {
  const [pending, setPending] = useState(true);
  const [show, setShow] = useState(false);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [createBou, setCreateBon] = useState(false);
  const [images, setImages] = useState("");
  const [editData, setEditData] = useState({});

  let image_baseurl = `${endPoints.apiBaseUrl}`;

  // Avoid a layout jump when reaching the last page with empty rows.

  // console.log("image_baseurl",image_baseurl);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchBetData();
  }, []);

  const fetchBetData = async (data) => {
    let url = `${P2PsportEndPoint.apiBaseUrl}${P2PsportEndPoint.api.GET_POOL_RESULTS}`;
    setIsLoading(true);
    await getAllSportData(url)
      .then((response) => {
        console.log("data", response.data);
        setIsLoading(false);
        if (response.status === "success") {
          setRows(response.data);

          setPending(false);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };
  const onClose = () => {
    setCreateBon(false);
    fetchBetData();
  };

  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div
                  className="col-md-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #444",
                  }}
                >
                  <h3
                    className="mb-2"
                    style={{ fontFamily: "ArticulatCF-Bold" }}
                  >
                    Bet Results
                  </h3>
                  {/* <Button
                    variant="primary"
                    className="mrglft10"
                    style={{ height: "fit-content" }}
                    onClick={() => {
                      setEditData({});
                      setCreateBon(true);
                    }}
                  >
                    Add Bonus
                  </Button> */}
                </div>
              </div>
              {/* <div style={{  width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        checkboxSelection
        getRowId={(row) => row.id_bonus}
      />
    </div> */}

              <div className="container-fluid table-custom">
                <div className="row" style={{ padding: "5px 0px 20px 0px" }}>
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        aria-label="a dense table"
                        stickyHeader
                        aria-label="sticky table"
                        sx={{ minWidth: 500 }}
                        aria-label="custom pagination table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Pool Name</TableCell>
                            <TableCell align="center">User Id</TableCell>
                            <TableCell align="center">Bet Id</TableCell>
                            <TableCell align="center">Event date</TableCell>
                            <TableCell align="center">Sports</TableCell>
                            <TableCell align="center">Rank</TableCell>
                            <TableCell align="center">Event Name</TableCell>
                            <TableCell align="center">Bet payout</TableCell>
                            <TableCell align="center">Payout %</TableCell>
                            <TableCell align="center"> Pool Price</TableCell>
                            <TableCell align="center">Bet Status</TableCell>
                            <TableCell align="center">Bet Result</TableCell>
                            <TableCell align="center">Pool status</TableCell>
                            {/* <TableCell align="center">Players</TableCell> */}
                            {/* <TableCell align="center">Start date</TableCell>
                            <TableCell align="center">End date</TableCell>

                            <TableCell align="center">Actions</TableCell> */}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(rowsPerPage > 0
                            ? rows.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            : rows
                          ).map((row) => (
                            <TableRow
                              key={row.idUser}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell align="center">{row.poolName}</TableCell>
                              <TableCell align="center">
                                {row.userId}
                              </TableCell>
                              <TableCell align="center">
                                {row?._id}
                              </TableCell>

                              {/* <TableCell align="center">
                                {row.poolId}
                              </TableCell> */}
                               <TableCell align="center">
                                {moment
                                  .utc(row.eventDate)
                                  .format("MMM Do YYYY, h:mm a")}
                              </TableCell>
                              <TableCell align="center">{row?.sport?.name}</TableCell>
                              <TableCell align="center">{row?.rank}</TableCell>
                              <TableCell align="center">{row?.eventName}</TableCell>
                              <TableCell align="center">{row?.status === "Active" ? "Pending" : `$${row?.winAmount?.toFixed(2)}`}</TableCell>
                              <TableCell align="center">{row?.winPayout}</TableCell>
                              <TableCell align="center">${row?.poolPrice}</TableCell>
                              <TableCell align="center">{row?.status}</TableCell>
                               <TableCell align="center" style={{textTransform:"capitalize"}}>{row?.defineresult}</TableCell>
                              <TableCell align="center">{row?.poolSizeFilled}{"/"}{row?.poolSize}</TableCell>

                              {/* <TableCell align="center">
                                {row?.players?.map((item, index) => (
                                  <div key={index}>
                                    {item?.name} —{" "}
                                    {item?.fantasypoint}{" "}Pts
                                  </div>
                                ))}
                              </TableCell> */}
                              {/* <TableCell align="center">
                                {moment
                                  .utc(row.startTime)
                                  .format("MMMM Do YYYY, h:mm a")}
                              </TableCell>

                              <TableCell align="center">
                                {moment
                                  .utc(row.endTime)
                                  .format("MMMM Do YYYY, h:mm a")}
                              </TableCell> */}

                              {/* <TableCell align="center">
                                {
                                  <AiOutlineEdit
                                    size={20}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setCreateBon(true);
                                      setEditData(row);
                                    }}
                                  />
                                }
                              </TableCell> */}
                            </TableRow>
                          ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={12}
                              count={rows.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BetResult;
